import { z } from 'zod';
import { SourceSystem } from '../enums.js';
import { IsoDateTime, UuidString } from '../primitives.js';

/** SerialNo — foundation, редко используется в Phase 1. */
export const SerialNo = z.object({
  id: UuidString,
  entity_id: UuidString,
  serial_no: z.string().min(1),
  item_id: UuidString,
  batch_id: UuidString.nullable(),
  warehouse_id: UuidString.nullable(),
  status: z.enum(['active', 'delivered', 'scrapped']).default('active'),
  source_system: SourceSystem,
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type SerialNo = z.infer<typeof SerialNo>;
